import classNames from 'classnames';
import React, { useState } from 'react';
import { InputNumber } from '@meitu/saas-ui';
import { ColorGroup } from '@meitu/xdesign-widgets';
import './index.less';

interface IColorInputGroup {
    disabled: boolean;
    width: number;
    color: string;
    showInput?: boolean;
    min?: number;
    max?: number;
    onChange: (value: number | null) => void;
    onChangeAfter: (value: number | null) => void;
    onAdjustColor: (color: string) => void;
    onAdjustColorAfter: (color: string, isBrandColor: boolean) => void;
    onColorPickerOpenChange: (open: boolean) => void;
    onToggleBizTab: (bizTab: string) => void;
}
const ColorInputGroup: React.FC<IColorInputGroup> = (props) => {
    const {
        disabled,
        width,
        color,
        showInput = true,
        min = 0,
        max = 100,
        onChange,
        onChangeAfter,
        onAdjustColor,
        onAdjustColorAfter,
        onColorPickerOpenChange,
        onToggleBizTab,
    } = props;

    const [isActive, setIsActive] = useState<boolean>(false);
    return (
        <div
            className={classNames('color-input-group', {
                'color-input-group--disabled': disabled,
                'color-input-group--active': isActive,
            })}
        >
            {showInput ? (
                <InputNumber
                    value={width}
                    min={min}
                    max={max}
                    onChange={(value) => {
                        if (!isActive) setIsActive(true);
                        onChange(value);
                    }}
                    onChangeAfter={(value) => {
                        setIsActive(false);
                        onChangeAfter(value);
                    }}
                    onFocus={() => setIsActive(true)}
                    onBlur={() => setIsActive(false)}
                    showStepBtn={false}
                    style={{ width: 35 }}
                />
            ) : null}
            <ColorGroup
                popupTriggerSize={{
                    width: 26,
                    height: 26,
                }}
                color={color}
                setColor={(color) => onAdjustColor(color)}
                setColorAfter={(color, _, { isBrandColor }) => {
                    onAdjustColorAfter(color, isBrandColor);
                }}
                onOpenChange={onColorPickerOpenChange}
                showIcon={false}
                popupOverlayClassName="style-color-picker style-color-row-picker"
                placement="left"
                onToggleBizTab={onToggleBizTab}
            />
        </div>
    );
};

export default React.memo(ColorInputGroup);
